"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpendoorLogoSvg = void 0;
const react_1 = __importDefault(require("react"));
/**
 * The Opendoor logo!
 */
const OpendoorLogoSvg = (_a) => {
    var { color = 'black' } = _a, props = __rest(_a, ["color"]);
    return (react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "64", height: "64", viewBox: "0 0 64 64", version: "1.1", stroke: "none" }, props),
        react_1.default.createElement("path", { className: 'bg-' + color, d: "m 41.808801,24.720994 c 0,-15.5083396 -2.651489,-21.936765 -9.941304,-21.936765 -6.4289,0 -9.676772,4.5065348 -9.676772,20.147614 0,15.44197 2.518748,21.804499 9.941304,21.804499 6.56164,0 9.676772,-4.440165 9.676772,-20.015348 M 9.5988812,24.323721 C 9.5988812,6.8930168 21.594342,2.2315002e-7 32.265244,2.2315002e-7 43.664321,2.2315002e-7 54.401119,6.8266467 54.401119,23.26322 c 0,17.56297 -11.995935,24.256877 -22.666363,24.256877 -11.399551,0 -22.1358748,-7.29029 -22.1358748,-23.196376" }),
        react_1.default.createElement("path", { className: 'bg-' + color, d: "m 52.061333,61.542882 c -1.087522,-1.442603 -5.277851,-7.00158 -5.277851,-7.00158 -0.393006,-0.52148 -1.066663,-0.83579 -1.789624,-0.83579 h -25.98819 c -0.722961,0 -1.396618,0.31431 -1.789624,0.83579 l -5.276903,7.000632 c -0.167348,0.221866 -0.256473,0.480709 -0.256473,0.744768 v 1.068559 C 11.682668,63.71129 11.971852,64 12.327881,64 H 51.67212 c 0.356028,0 0.644738,-0.28871 0.644738,-0.644739 v -1.068559 c 0,-0.264059 -0.08818,-0.521954 -0.255525,-0.74382" })));
};
exports.OpendoorLogoSvg = OpendoorLogoSvg;
exports.default = exports.OpendoorLogoSvg;
